const springTask = (state = {}, action) => {
  switch (action.type) {
    case 'SET_SPRING_TASK':
      return action.springTask;
    default:
      return state;
  }
};

const curTime = (state = {}, action) => {
  switch (action.type) {
    case 'SET_CURTIME':
      return action.curTime;
    default:
      return state;
  }
};


export { springTask, curTime };
